import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useTheme, CacheProvider } from '../../../providers';
const CSS = {
    badge: ({ position }) => css({
        display: 'inline-block',
        position: 'absolute',
        ...position,
    }),
};
export const Badge = observer((properties) => {
    const globalTheme = useTheme();
    const props = {
        // default props
        position: {
            top: 0,
            left: 0,
        },
        // global theme
        ...globalTheme?.components?.badge,
        // props
        ...properties,
        ...properties.theme?.components?.badge,
    };
    const { content, children, position, disableStyles, className, style } = props;
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.badge({ position }), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return (jsx(CacheProvider, null,
        jsx("div", { ...styling, className: classnames('ss__badge', className) }, content || children)));
});
